<template>
  <div>
    <!-- Total Stock Overview Start -->
    <div class="row" style="padding-right:2%">
        
        <div class="offset-md-10 col-md-2 highlightFilter">
            <button
                type="button"
                class="mt-1 btn btn-warning w-100"
                style="height:90%"
                @click="exportExcel('mainDealerStock', 'Main Dealer Stock')"
            >Download CSV <i class="fas fa-download"></i></button>
        </div>
    </div>

    <div style="padding: 0px 1.5%;" class="mt-2">
        <div class="row shadow rounded heightStats" style="background-color:white;">
            <div class="col-12 col-md statsPadding h-100">
                <div class="borderRight borderBottom h-100" style="padding-right:2%;">
                    <div class="row Aligner" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                        <div class="col-12 col-md-6">
                            <img src="@/assets/img/Highlights/Intransit.png" style="width:100%;"/>
                        </div>
                        <div class="col-12 col-md-6">
                            <p>In Transit AHM-MD</p>
                            <h4 v-if="dataDocument">{{numberWithCommas(dataDocument.intransit_ahm_md)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                        <div class="col-6" style="height:60px;">
                            <p>SIPB</p>
                            <h4 v-if="dataSipbUnfill">{{dataSipbUnfill.sipb && dataSipbUnfill.sipb >= 0 ? numberWithCommas(dataSipbUnfill.sipb) : 0}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            <p>Unfill</p>
                            <h4 v-if="dataSipbUnfill">{{dataSipbUnfill.unfill && dataSipbUnfill.unfill >= 0 ? numberWithCommas(dataSipbUnfill.unfill) : 0}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <!-- <div class="row Aligner mt-2" :class="(mobile) ? 'h-100' : 'h-50'">
                        <div class="col-6">
                            <img src="@/assets/img/Highlights/Intransit.png" style="width:100%;"/>
                        </div>
                        <div class="col-6">
                            <p>Virtual In Transit AHM-MD</p>
                            <h4 v-if="data">{{numberWithCommas(data.virtual_intransit_ahm_md)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-12 col-md statsPadding h-100">
                <div class="borderRight borderBottom h-100" style="padding-right:2%;">
                    <div class="row Aligner" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                        <div class="col-12 col-md-6">
                            <img src="@/assets/img/Highlights/Dealer.png" style="width:100%;"/>
                        </div>
                        <div class="col-12 col-md-6">
                            <p>Main Dealer On-Hand Stock</p>
                            <h4 v-if="data">{{data.maindealer > 0 ? numberWithCommas(data.maindealer) : 0}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                        <div class="col-6" style="height:60px;">
                            <p>On Hand</p>
                            <h4 v-if="data && dataDocument">{{data.maindealer - dataDocument.do_pending >= 0 ? numberWithCommas(data.maindealer - dataDocument.do_pending) : 0}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6"  style="height:60px;">
                            <p>DO Pending</p>
                            <h4 v-if="dataDocument">{{numberWithCommas(dataDocument.do_pending)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            <p>Virtual Stock</p>
                            <h4 v-if="dataVirtual">{{numberWithCommas(dataVirtual.virtual_stock_md)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            <p>Virtual Sales</p>
                            <h4 v-if="dataVirtual">{{numberWithCommas(dataVirtual.virtual_sales)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <!-- <div class="row Aligner mt-2" :class="(mobile) ? 'h-100' : 'h-50'">
                        <div class="col-6">
                            <img src="@/assets/img/Highlights/Dealer.png" style="width:100%;"/>
                        </div>
                        <div class="col-6">
                            <p>Main Dealer Virtual Stock</p>
                            <h4 v-if="data">{{numberWithCommas(data.maindealer_virtual_stock)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-12 col-md statsPadding h-100">
                <div class="borderRight borderBottom h-100" style="padding-right:2%;">
                    <div class="row Aligner h-50">
                        <div class="col-6">
                            <img src="@/assets/img/Highlights/Intransit.png" style="width:100%;"/>
                        </div>
                        <div class="col-6">
                            <p>In Transit MD - D</p>
                            <h4 v-if="data">{{numberWithCommas(data.intransit_md_to_d)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">

                        <div class="col-6" style="height:60px">
                            <p>Stock Jatim</p>
                            <h4 v-if="data">{{numberWithCommas(data.intransit_jatim)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6" style="height:60px">
                            <p>Stock NTT</p>
                            <h4 v-if="data">{{numberWithCommas(data.intransit_ntt)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            <p>Virtual Stock</p>
                            <h4 v-if="dataVirtual">{{numberWithCommas(dataVirtual.virtual_stock_intransit)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            <p>Indent</p>
                            <h4 v-if="dataIndent">{{numberWithCommas(dataIndent.intransit_md_to_d)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md statsPadding h-100">
                <div class="borderRight borderBottom h-100" style="padding-right:2%;">
                    <div class="row Aligner h-50">
                        <div class="col-6">
                            <img src="@/assets/img/Highlights/Dealer.png" style="width:100%;"/>
                        </div>
                        <div class="col-6">
                            <p>Dealer On-Hand Stock</p>
                            <h4 v-if="data">{{numberWithCommas(data.dealer)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">

                        <div class="col-6">
                            <p>Stock Jatim</p>
                            <h4 v-if="data">{{numberWithCommas(data.stockJatim)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            <p>Stock NTT</p>
                            <h4 v-if="data">{{numberWithCommas(data.stockNtt)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                            
                        </div>
                        <div class="col-6">
                            <p>Indent</p>
                            <h4 v-if="dataIndent">{{numberWithCommas(dataIndent.dealer_onhand)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <!-- <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                        <div class="col-6" style="margin-top:68px">
                            <p>Virtual Stock</p>
                            <h4 v-if="dataVirtual">{{numberWithCommas(dataVirtual.virtual_stock_dealer)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-12 col-md statsPadding h-100">
                <div style="padding-right:2%;" class="h-100">
                    <div class="row Aligner h-50">
                        <div class="col-6">
                            <img src="@/assets/img/Highlights/Total.png" style="width:100%;"/>
                        </div>
                        <div class="col-6">
                            <p>Total Stock</p>
                            <h4 v-if="data && dataDocument && dataVirtual">{{numberWithCommas(data.maindealer  + data.dealer + dataDocument.intransit_ahm_md + data.intransit_md_to_d)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                    <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                        <div class="col-6">
                            <p>Serah Terima</p>
                            <h4 v-if="dataIndent">{{numberWithCommas(dataIndent.total_stock)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                        <div class="col-6">
                        </div>
                        <div class="col-6">
                            <p>Virtual Stock</p>
                            <h4 v-if="dataVirtual">{{numberWithCommas(dataVirtual.total_virtual_stock)}}</h4>
                            <h4 v-else>Loading.....</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <p class="mt-2" style="color:grey;font-size:13px;font-weight:bold">Stock Calculated as of {{new moment().format('MMM DD, Y HH:mm')}}</p> -->
    </div>
    <!-- Total Stock Overview End-->
  </div>
</template>

<script>
    const XLSX = require('xlsx')
    import moment from 'moment'

  export default {
    data () {
      return {
        mobile : this.isMobile(),
        moment : moment
      }
    },
    props: ['data', 'dataDocument', 'dataVirtual', 'dataSipbUnfill' , 'dataIndent'],
    mounted () {

    },
    methods : {
        numberWithCommas(x) {
            return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        exportExcel () {
            let header = ['data', 'dataDocument', 'dataVirtual']


            let exportFileName = 'Total Stock Overview.xls'
            // let wb = XLSX.utils.book_new()
            // let ws = XLSX.utils.json_to_sheet(this.data[data], {raw: true})
            // XLSX.utils.book_append_sheet(wb, ws, "SheetJS")
            // XLSX.writeFile(wb, exportFileName)
            let wb = XLSX.utils.book_new()
            // console.log(this.dataVirtual)
            for(var i = 0; i < header.length ; i ++) {
                var ws = XLSX.utils.json_to_sheet([this[header[i]]], {raw:true});
                XLSX.utils.book_append_sheet(wb, ws, header[i])
            }

            XLSX.writeFile(wb, exportFileName)
            // let dataCsv = []
			// 	XLSX.utils.book_append_sheet(wb, ws, 'Data')


            // for(var i = 0 ; i < header.length ; i++) {
            //     dataCsv.push(header[i] == 'data' ? 'Total Stock' : header[i] == 'dataDocument' ? 'Data Stock Document' : 'Virtual Stock Data')
            //     var ws = XLSX.utils.json_to_sheet([this[header[i]]], {raw:true});
                
			//     dataCsv.push(XLSX.utils.sheet_to_csv(ws));
            // }   

            // dataCsv = dataCsv.join('\n');

			// const blob = new Blob([s2ab(dataCsv)], {
			// 	type: 'application/octet-stream'
            // });
            
			// var a = document.createElement("a");
			// document.body.appendChild(a);
			// a.style = "display: none";
			// let url = window.URL.createObjectURL(blob);
			// a.href = url;
			// a.download = `Total Stock Overview.csv`;
			// a.click();
			// window.URL.revokeObjectURL(url);
        }
    }
  }

function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}
</script>

<style scoped>
  @media screen and (min-width: 950px) {
      .borderRight {
        border-right: 2px solid #F4F4F4;
      }

      .heightStats {
        height: 325px;
      }

      .heightStockDays {
        height: 100%;
        min-height:400px;
      }

      .statsPadding {
        padding: 30px 1%;
      }

      h4 {
        overflow-wrap: break-word;
      }
  }

  @media only screen and (max-device-width: 768px) {
      .borderBottom {
        border-bottom: 2px solid #F4F4F4;
      }

      .heightStats {
        height: 100%;
      }

      .heightStockDays {
        height: 100%;
      }

      .statsPadding {
        padding: 15px 1%;
      }
  }
  .Aligner {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Aligner .col-6 p {
    margin-bottom: 10px;
  }
</style>
